module.exports = __webpack_public_path__ + "img/large_logo.29052fea.jpg";